import { FocusEventHandler, KeyboardEventHandler, useEffect, useRef, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Box, Button, Card, Divider, Flex, Image, Input, Spinner, Switch, Text, Textarea, useColorMode } from 'theme-ui';
import { ActionModuleTab } from './ActionModuleTab';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { createActionHighlightSuccess, createBCDoneHighlight, getActionByName, getActionIdSuccess, getAllTemplateChecklist, getBcPcRevStages } from '../../../store/actions/action.Highlighters';
import { RootState } from '../../../../@types';
import CustomTooltip from '../../CustomTooltip';
import { rolePermissionsHighLighters } from '../../../utils/CustomHandler';
import { getAllTaskViewByStageId } from '../../../store/actions/project.action';
import editIcon from "../../assets/images/edit.svg";
import CreatableSelect from 'react-select/creatable';
import { Inputform } from '../../forms-component/InputForm';
import theme from '../../../theme';
import MarkDownParagraph from '../../forms-component/MarkDownParagraph';
import moment from 'moment';
import { MultiSelect } from 'react-multi-select-component';
import { useParams, useLocation } from 'react-router-dom';
import { convertMsToHHMM, timeToMs } from '../../../utils/GenerateQueryString';
import { LuPenLine } from 'react-icons/lu';


interface Option {
    label: string;
    value: string;
    timeEstimate?: number;
}
const components = {
    DropdownIndicator: null,
};

const createOption = (label: string) => ({
    label,
    value: label,
});

const msToHours = (ms: number) => (ms / (1000 * 60 * 60)).toFixed(1);

const ActionBcPcChecklist = ({ Open, setOpen, selectedHighlight, actionObject, keys, actionId, status }: any) => {
    const { auther } = useSelector((state: RootState) => state.auth);
    const is_Task_Worker = auther?.Role?.map(role => role?.RoleName).every(role => role.toLocaleLowerCase() === "task worker")
    const { stageAllTaskView } = useSelector((state: any) => state.project);
    const dispatch = useDispatch();
    // treat any status containing 'delivered' (case-insensitive) as delivered
    const isDelivered = typeof status === 'string' && status.toLowerCase().includes('delivered');
    const { actionHighlights, loader } = useSelector((state: any) => state.actionHighlight);
    const { stageId, taskId } = useParams<{ stageId?: string; taskId?: string }>();
    const location = useLocation();
    const isEditTaskRoute = location?.pathname.includes('/edit-task');
    const isEditStagesRoute = location?.pathname.includes('/edit-stages');
    const [isSwitchChecked, setIsSwitchChecked] = useState(false);
    const isBcChecked = actionHighlights?.payload?.Description?.every((check: any) => check.isChecked === true) && actionHighlights?.payload?.Description?.length > 0
    const [inputValue, setInputValue] = useState('');
    const [emailLinks, setEmailLinks] = useState<string[]>([]);
    const [isEmailEditing, setIsEmailEditing] = useState<boolean>(false);
    const [editedEmailLinks, setEditedEmailLinks] = useState<{ label: string; value: string }[]>([]);
    const [taskName, setTaskName] = useState<Option[]>([]);
    const [isTaskEditing, setIsTaskEditing] = useState(false);
    const [editedTasks, setEditedTasks] = useState<Option[]>([]);
    const [timeEstimates, setTimeEstimates] = useState<Record<string, string | number>>({});
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [isNameEditing, setIsNameEditing] = useState<boolean>(false);
    const [nameInputValue, setNameInputValue] = useState<string>(actionHighlights?.payload?.name || "");
    const [description, setDescription] = useState<string>("");
    const [isDeltaEditing, setIsDeltaEditing] = useState<boolean>(false);
    const [deltaInputValue, setDeltaInputValue] = useState<string>(actionHighlights?.payload?.delta || "");
    const taskIdSet = new Set<string>();
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const isStageMatch = stageId === actionHighlights?.stageId;
    const uniqueTasks = stageAllTaskView?.filter((obj: any) => {
        const taskId = obj?.taskId?._id;
        const isUnique = taskId && !taskIdSet?.has(taskId);
        if (isUnique) {
            taskIdSet?.add(taskId);
        }
        return isUnique;
    });

    const taskOptions: Option[] = uniqueTasks?.map((obj: any) => ({
        label: obj?.taskId?.name,
        value: obj?._id,
        timeEstimate: obj?.timeEstimate || 0,
    }));

    const togglePopover = () => {
        setOpen(!Open);
    }

    useEffect(() => {
        dispatch(getAllTemplateChecklist({ query: "subtasks" }))
    }, [dispatch])
    useEffect(() => {
        if (actionHighlights?.payload?.description) {
            setDescription(actionHighlights?.payload?.description);
        }
    }, [actionHighlights]);
    useEffect(() => {
        setIsSwitchChecked(actionHighlights?.payload?.isDone)
    }, [actionHighlights?.payload?.isDone])

    const handleEditClick = () => {
        if (isStageMatch) {
            setIsEditing(true);
        }
    };

    const handleNameEditClick = () => {

        if (isStageMatch) {
            setIsNameEditing(true);
            setNameInputValue(actionHighlights?.payload?.name || "");
        }
    };
    const handleDeltaEditClick = () => {
        if (isStageMatch && !isDelivered) {
            setIsDeltaEditing(true);
            setDeltaInputValue(actionHighlights?.payload?.delta || "");
        }
    };

    const handleDeltaCancelClick = () => {
        setIsDeltaEditing(false);
        setDeltaInputValue(actionHighlights?.payload?.delta || "");
    };

    const handleDeltaSaveClick = () => {

        const payload = {
            actionType: selectedHighlight?.name,
            delta: deltaInputValue,
            stageId: actionObject?.stageId
        };

        dispatch(createBCDoneHighlight(payload, actionHighlights?._id));
        setIsDeltaEditing(false);
    };
    const handleNameCancelClick = () => {
        setIsNameEditing(false);
    };
    const handleDescriptionCancelClick = () => {
        setIsEditing(false);
    };
    const handleNameSaveClick = () => {
        const payload = {
            actionType: selectedHighlight?.name,
            name: nameInputValue,
            stageId: actionObject?.stageId
        };
        dispatch(createBCDoneHighlight(payload, actionHighlights?._id));
        setIsNameEditing(false);
    };

    const handleSaveClick = () => {
        const payload = {
            actionType: selectedHighlight?.name,
            description: description,
            stageId: actionObject?.stageId
        };
        dispatch(createBCDoneHighlight(payload, actionHighlights?._id));
        setIsEditing(false);
    };
    const handleTaskEditClick = () => {
        setIsTaskEditing(true);
        setEditedTasks(taskName);
    };
    const prevTaskTimes: Record<string, number> = {};
    actionHighlights?.payload?.taskEstimateList?.forEach((item: { taskId: string; newTime: number }) => {
        prevTaskTimes[item.taskId] = item.newTime;
    });

    const handleTaskSaveClick = (isTaskSelectionChanged: boolean) => {
        setIsTaskEditing(false);
        setEditingTaskId(null);
        const payload: any = {
            actionType: actionHighlights?.actionType,
            stageId: actionHighlights?.stageId,
        };

        // Always include taskId array with current selected tasks
        payload.taskId = editedTasks.map(task => task.value);

        // If tasks selection has changed
        if (isTaskSelectionChanged) {
            // Create a map of previous task estimates from payload
            const prevTaskEstimates: Record<string, any> = {};
            actionHighlights?.payload?.taskEstimateList?.forEach((item: any) => {
                prevTaskEstimates[item.taskId] = item;
            });

            // Get list of previous task IDs
            const prevTaskIds = taskName.map(task => task.value);
            const currentTaskIds = editedTasks.map(task => task.value);

            // Add oldTaskId key to payload with previously selected task IDs
            payload.oldTaskId = prevTaskIds;

            const removedTaskIds = prevTaskIds.filter(id => !currentTaskIds.includes(id));

            // Create taskEstimateList with ONLY removed tasks
            const taskEstimateList = [];

            // For removed tasks, set estimatedTime to 0 and adjust newTime
            for (const taskId of removedTaskIds) {
                const prevEstimate = prevTaskEstimates[taskId];
                const option = taskOptions.find(opt => opt.value === taskId);
                const originalTaskEstimateTime = option?.timeEstimate || 0;

                if (prevEstimate) {
                    const oldEstimateTime = prevEstimate.estimatedTime || 0;
                    // Always use absolute value to ensure result is positive
                    const adjustedNewTime = Math.abs(originalTaskEstimateTime - oldEstimateTime);

                    taskEstimateList.push({
                        taskId: taskId,
                        estimatedTime: 0,
                        newTime: adjustedNewTime
                    });
                }
            }

            if (taskEstimateList.length > 0) {
                payload.taskEstimateList = taskEstimateList;
            }
        } else {
            const taskEstimateList = editedTasks.map(task => {
                const option = taskOptions.find(opt => opt.value === task.value);
                const backendTimeEstimate = option?.timeEstimate || 0;
                const inputTimeMs = timeToMs(timeEstimates[task.value]) || 0;
                return {
                    taskId: task.value,
                    newTime: backendTimeEstimate + inputTimeMs,
                    estimatedTime: inputTimeMs
                };
            });
            payload.taskEstimateList = taskEstimateList;
        }

        dispatch(createBCDoneHighlight(payload, actionHighlights?._id));
        setIsEditing(false);
    };
    const handleTaskCancelClick = () => {
        setIsTaskEditing(false);
        setEditedTasks([]);
    };
    const handleTextareaChange = (event: any) => {
        setDescription(event.target.value);
    };

    useEffect(() => {
        setEmailLinks(actionHighlights?.payload?.emailLink || []);
    }, [actionHighlights?.payload?.emailLink]);

    const handleEmailEditClick = () => {
        if (isStageMatch) {
            setIsEmailEditing(true);
            setEditedEmailLinks(emailLinks?.map(link => createOption(link)));
        }
    };

    const handleEmailSaveClick = () => {
        setIsEmailEditing(false);

        const emailLinkValues = editedEmailLinks?.map((link: any) => link?.value);

        setEmailLinks(emailLinkValues);

        const payload = {

            emailLink: emailLinkValues,
        };

        dispatch(createBCDoneHighlight(payload, actionHighlights._id));
    };

    const handleEmailCancelClick = () => {
        setIsEmailEditing(false);
        setEditedEmailLinks([]);
    };

    useEffect(() => {
        return () => {
            dispatch(getActionIdSuccess([]))
            dispatch(createActionHighlightSuccess([]))
        }
    }, [])

    const toggleBCDone = (value: boolean) => {
        if (isStageMatch) {
            const payload = {
                actionType: selectedHighlight?.name,
                isDone: value,
                stageId: actionObject?.stageId
            };
            dispatch(createBCDoneHighlight(payload, actionHighlights?._id));
            setIsSwitchChecked(value);
        }
    }
    useEffect(() => {
        function handleKeyDown(event: any) {
            if (Open && event.key === 'Escape') {
                setOpen(!Open)
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [Open]);
    const handleKeyDown: KeyboardEventHandler = (event) => {
        if (!inputValue) return;
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                setEditedEmailLinks((prev) => [...prev, createOption(inputValue)]);
                setInputValue('');
                event.preventDefault();
        }
    };

    const handleBlur: FocusEventHandler = () => {
        if (inputValue.trim() !== '') {
            setEditedEmailLinks((prev) => [...prev, createOption(inputValue)]);
            setInputValue('');
        }
    };
    useEffect(() => {
        if (textareaRef?.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px `;
            //   textareaRef.current.style.marginTop = "20px";
        }
    }, [isNameEditing]);
    const switchLabel = isSwitchChecked ? 'Background Change Done' : 'Background Change InProgress';

    useEffect(() => {
        if (Open) {
            if (actionHighlights?.stageId) {
                dispatch(getAllTaskViewByStageId(actionHighlights?.stageId));
            }
        }
    }, [Open, actionHighlights])

    useEffect(() => {
        if (Open && stageAllTaskView && actionHighlights?.payload?.taskId) {
            const matchingTaskNames: any = [];
            for (const task of stageAllTaskView) {
                if (actionHighlights?.payload?.taskId?.includes(task?._id)) {
                    matchingTaskNames.push({ label: task.taskId.name, value: task._id });
                }
            }
            setTaskName(matchingTaskNames);
        }
    }, [Open, stageAllTaskView, actionHighlights]);

    useEffect(() => {
        // Set initial timeEstimates from payload
        if (actionHighlights?.payload?.taskEstimateList) {
            const initialTimeEstimates: Record<string, string> = {};
            actionHighlights?.payload?.taskEstimateList?.forEach((item: any) => {
                initialTimeEstimates[item?.taskId] = convertMsToHHMM(item?.newTime);
            });
            setTimeEstimates(initialTimeEstimates);
        }
    }, [actionHighlights]);

    const [editingTaskId, setEditingTaskId] = useState<string | null>(null);
    const [tempTimeEstimates, setTempTimeEstimates] = useState<Record<string, string>>({});
    const handleTimeEstimateSave = (task: any) => {
        const option = taskOptions.find(opt => opt.value === task.value);
        const backendTimeEstimate = option?.timeEstimate || 0;
        const inputTimeMs = timeToMs(tempTimeEstimates[task.value]) || 0;
        const estimateObj = actionHighlights?.payload?.taskEstimateList?.find((t: any) => t.taskId === task.value);
        const oldEstimateTime = estimateObj?.estimatedTime || 0;

        if (oldEstimateTime === inputTimeMs) {
            setEditingTaskId(null);
            setTempTimeEstimates({});
            return;
        }

        const newTime = backendTimeEstimate - oldEstimateTime + inputTimeMs;
        const payload = {
            actionType: actionHighlights?.actionType,
            stageId: actionHighlights?.stageId,
            taskEstimateList: [{
                taskId: task.value,
                newTime: Math.max(0, newTime),
                estimatedTime: inputTimeMs
            }]
        };

        // Only update state and call API if changed

        setTimeEstimates(prev => ({
            ...prev,
            [task.value]: tempTimeEstimates[task.value]
        }));

        dispatch(createBCDoneHighlight(payload, actionHighlights?._id, (res: any) => {
            if (res.status === 200) {
                dispatch(getActionByName(actionObject, { name: selectedHighlight?.name }));
                dispatch(getBcPcRevStages(actionObject?.projectId, { name: selectedHighlight?.name }));
            }
        }));

        setEditingTaskId(null);
        setTempTimeEstimates({});
    };

    const handleTimeEstimateCancel = () => {
        setEditingTaskId(null);
        setTempTimeEstimates({});
    };
    const handleForceComplete = () => {
        const payloadObj = {
            actionType: selectedHighlight?.name,
            stageId: actionObject?.stageId,
            isCompleted: true,
        }
        dispatch(createBCDoneHighlight(payloadObj, actionHighlights?._id, (res: any) => {
            if (res.status === 200) {
                dispatch(getActionByName(actionObject, { name: selectedHighlight?.name }));
                dispatch(getBcPcRevStages(actionObject?.projectId, { name: selectedHighlight?.name }));
                togglePopover();
            }
        }));

    }
    const isDeliveredCompleted = actionHighlights?.payload?.isCompleted === true;
    const [colorMode] = useColorMode();
    const modalHeader = colorMode === "light" ? "#fff" : "#20283c";
    const label = colorMode === 'light' ? "#0A0A0A" : "#fff";
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={togglePopover}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    return (
        <Modal isOpen={Open} scrollable size="xl" centered keyboard={false}>
            <ModalHeader toggle={togglePopover} close={closeButton} style={{ backgroundColor: modalHeader }}>
                <Flex sx={{ gap: "1rem", }}>
                    <Image src={selectedHighlight?.icon} />
                    <Text sx={{ color: selectedHighlight?.color }}>{selectedHighlight?.name?.toUpperCase()}</Text>
                </Flex>
            </ModalHeader>
            {!isStageMatch && <Text className='ps-3' sx={{ color: `${theme?.colors?.danger}`, backgroundColor: modalHeader }}>Note: This content is for viewing only and cannot be modified </Text>
            }
            <ModalBody className="scrollable-modal-body" style={{ backgroundColor: modalHeader }}>
                <Card sx={{ boxShadow: "none", border: `1px solid ${theme?.colors?.lightbackground}`, borderRadius: "12px", padding: "8px 16px", position: "relative", backgroundColor: colorMode === "light" ? "#fff" : "#20283c" }}>
                    {selectedHighlight?.name === 'Background Change' && (
                        <Flex sx={{ position: 'absolute', top: '8px', right: '8px' }}>
                            <Box>
                                {(is_Task_Worker && rolePermissionsHighLighters.includes(selectedHighlight?.name)) ? (
                                    <CustomTooltip id={switchLabel.trim()} title="Permission Denied">
                                        <Switch sx={{ cursor: "not-allowed" }} label={switchLabel} checked={isSwitchChecked} />
                                    </CustomTooltip>
                                ) : (
                                    <Switch
                                        disabled={!isStageMatch || !isBcChecked}
                                        label={switchLabel}
                                        checked={isSwitchChecked}
                                        onChange={(e: any) => toggleBCDone(e?.target?.checked)}
                                    />
                                )}
                            </Box>
                        </Flex>
                    )}
                    <Flex sx={{ flexDirection: 'column' }}>
                        <Flex sx={{ alignItems: 'center' }}>
                            <Text variant="SelectLabel" sx={{ flex: '1', color: label }}>Name:</Text>
                            {!isNameEditing && isStageMatch && !isDeliveredCompleted && (
                                <>
                                    {colorMode === 'light' ? (
                                        <Image
                                            src={editIcon}
                                            sx={{ cursor: 'pointer', width: '24px', height: '24px', ml: '1rem', mt: '10px' }}
                                            onClick={handleNameEditClick}
                                        />
                                    ) : (
                                        <LuPenLine onClick={handleNameEditClick} style={{ cursor: 'pointer', width: '24px', height: '24px', marginLeft: '1rem', marginTop: '10px', color: 'white' }} />
                                    )}
                                </>
                            )}
                        </Flex>
                        <Box sx={{ mt: '6px' }}>
                            {!isNameEditing && (
                                <>
                                    <Textarea
                                        ref={textareaRef}
                                        value={actionHighlights?.payload?.name}
                                        placeholder={"Enter Name"}
                                        name={"name"}
                                        variant="PersonalDetailsInput"
                                        className="form-control"
                                        sx={{
                                            overflow: 'hidden',
                                            '::placeholder': { color: label, opacity: 0.6 },
                                            // Ensure focus does not get overridden by external .form-control styles
                                            '&:focus, &:focus-visible': {
                                                outline: 'none',
                                                boxShadow: '0 0 0 3px rgba(99,102,241,0.12)',
                                                // background: modalHeader + " !important",
                                                color: label + " !important",
                                                borderColor: 'rgba(255,255,255,0.06)'
                                            }
                                        }}
                                        disabled={!isStageMatch || isDeliveredCompleted}
                                    />
                                </>
                            )}
                            {isNameEditing && !isDeliveredCompleted && (
                                <Textarea
                                    value={nameInputValue}
                                    placeholder={"Enter Name"}
                                    name={"name"}
                                    sx={{ '::placeholder': { color: label }, color: label }}
                                    // type='text'
                                    // Max_Length={10}

                                    // Title_sx={{ color: "grey3" }}
                                    onChange={(e: any) => setNameInputValue(e.target.value)}
                                />
                            )}
                        </Box>
                        {isNameEditing && !isDeliveredCompleted && (
                            <Flex className="mt-3" sx={{ justifyContent: 'end', gap: '8px' }}>
                                <Button
                                    sx={{
                                        background: theme?.colors?.white,
                                        color: theme?.colors?.primary,
                                        border: `1px solid ${theme?.colors?.primary}`,
                                        textAlign: 'center',
                                        borderRadius: '12px',
                                    }}
                                    onClick={handleNameCancelClick}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    sx={{ background: theme?.colors?.primary, textAlign: 'center', borderRadius: '12px' }}
                                    onClick={handleNameSaveClick}
                                >
                                    Save
                                </Button>
                            </Flex>
                        )}
                        <Box sx={{ flexDirection: 'column' }}>
                            <Flex sx={{ alignItems: 'center' }}>
                                <Text variant="SelectLabel" sx={{ color: label }}>Description:</Text>
                                {!isEditing && isStageMatch && !isDeliveredCompleted && (
                                    <>
                                        {colorMode === 'light' ? (
                                            <Image
                                                src={editIcon}
                                                sx={{ cursor: 'pointer', width: '24px', height: '24px', ml: 'auto' }}
                                                onClick={handleEditClick}
                                            />
                                        )
                                            : (
                                                <LuPenLine onClick={handleEditClick} style={{ cursor: 'pointer', width: '24px', height: '24px', marginLeft: 'auto', color: 'white' }} />
                                            )}

                                    </>
                                )}
                            </Flex>
                            <Box sx={{ mt: '8px' }}>
                                {!isEditing ? (
                                    <Box className='ps-2' sx={{ minHeight: `${description?.length < 30 ? "65px" : "150px"}`, maxHeight: '300px', border: "2px solid rgb(247, 239, 229)", overflowY: "auto", borderRadius: "4px", resize: 'vertical', color: label }}>
                                        <MarkDownParagraph markdown={description} />
                                    </Box>
                                ) : (
                                    <>
                                        <Textarea
                                            value={description}
                                            onChange={handleTextareaChange}
                                            rows={description?.length > 30 ? 10 : 2}
                                            placeholder="Description..."
                                            disabled={!isStageMatch || isDeliveredCompleted}
                                            sx={{ color: label }}

                                        />
                                        <Flex className="mt-3" sx={{ justifyContent: 'end', gap: '8px' }}>
                                            <Button
                                                sx={{
                                                    background: theme?.colors?.white,
                                                    color: theme?.colors?.primary,
                                                    border: `1px solid ${theme?.colors?.primary}`,
                                                    textAlign: 'center',
                                                    borderRadius: '12px',
                                                }}
                                                onClick={handleDescriptionCancelClick}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                sx={{ background: theme?.colors?.primary, textAlign: 'center', borderRadius: '12px' }}
                                                onClick={handleSaveClick}
                                            >
                                                Save
                                            </Button>
                                        </Flex>
                                    </>
                                )}
                            </Box>
                        </Box>


                        {/* Other fields and components */}
                        <Box>
                            <Flex sx={{ alignItems: 'center' }}>
                                <Text variant="SelectLabel" sx={{ flex: '1', color: label }}>URL Links:</Text>
                                {!isEmailEditing && isStageMatch && !isDeliveredCompleted && (
                                    <>
                                        {colorMode === 'light' ? (
                                            <Image
                                                src={editIcon}
                                                sx={{ cursor: 'pointer', width: '24px', height: '24px', ml: '1rem' }}
                                                onClick={handleEmailEditClick}
                                            />
                                        ) : (
                                            <LuPenLine onClick={handleEmailEditClick} style={{ cursor: 'pointer', width: '24px', height: '24px', marginLeft: '1rem', color: 'white' }} />
                                        )}
                                    </>
                                )}
                            </Flex>
                            <Box sx={{ mt: '6px' }}>
                                {/* {!isEmailEditing ? (
                                    <CreatableSelect
                                        components={{ DropdownIndicator: null }}
                                        inputValue={inputValue}
                                        isClearable
                                        isMulti
                                        menuIsOpen={false}
                                        value={emailLinks?.map((link: string) => createOption(link))}
                                        onChange={(newValue: any) => {
                                            setEmailLinks(newValue?.map((item: any) => item.label));
                                        }}
                                        onInputChange={(newValue) => {
                                            setInputValue(newValue);
                                        }}
                                        placeholder=""
                                        styles={{
                                            valueContainer: (base) => ({
                                                ...base,
                                                maxHeight: '90px',
                                                overflowY: 'auto',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                paddingRight: '30px',
                                            }),
                                            control: (base) => ({
                                                ...base,
                                                border: '1px solid #f7efe5',
                                                borderRadius: '12px',
                                                minHeight: '48px',
                                                flexWrap: 'wrap',
                                                display: 'flex',
                                                position: 'relative',
                                            }),
                                            clearIndicator: (base) => ({
                                                ...base,
                                                position: 'absolute',
                                                right: '10px',
                                                top: '45%',
                                                transform: 'translateY(-95%)',
                                                zIndex: 1,
                                                padding: '0 5px',
                                                cursor: 'pointer',
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                            }),
                                        }}
                                        isDisabled={!isStageMatch || !isEmailEditing}
                                    />
                                ) */}

                                <Box sx={{ mt: '6px' }}>
                                    {!isEmailEditing ? (
                                        <Box className='px-2' sx={{
                                            border: `1px solid ${theme?.colors?.lightbackground}`, borderRadius: '4px',
                                        }}>
                                            {emailLinks?.map((link, index) => (
                                                <a key={index} href={link} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '4px 0' }}>
                                                    {link}
                                                </a>
                                            ))}
                                        </Box>
                                    )
                                        :
                                        (
                                            <>
                                                <CreatableSelect
                                                    components={{ DropdownIndicator: null }}
                                                    inputValue={inputValue}
                                                    isClearable
                                                    isMulti
                                                    menuIsOpen={false}
                                                    value={editedEmailLinks}
                                                    onChange={(newValue: any) => {
                                                        setEditedEmailLinks(newValue);
                                                    }}
                                                    isDisabled={isDelivered}
                                                    onInputChange={(newValue) => {
                                                        setInputValue(newValue);
                                                    }}
                                                    onKeyDown={handleKeyDown}
                                                    onBlur={handleBlur}
                                                    placeholder=""
                                                    styles={{
                                                        valueContainer: (base) => ({
                                                            ...base,
                                                            maxHeight: '90px',
                                                            overflowY: 'auto',
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            paddingRight: '30px',
                                                        }),
                                                        control: (base) => ({
                                                            ...base,
                                                            border: `1px solid ${theme?.colors?.lightbackground}`,
                                                            borderRadius: '12px',
                                                            minHeight: '48px',
                                                            flexWrap: 'wrap',
                                                            display: 'flex',
                                                            position: 'relative',
                                                        }),
                                                        clearIndicator: (base) => ({
                                                            ...base,
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '45%',
                                                            transform: 'translateY(-95%)',
                                                            zIndex: 1,
                                                            padding: '0 5px',
                                                            cursor: 'pointer',
                                                        }),
                                                        multiValue: (base) => ({
                                                            ...base,
                                                        }),
                                                    }}
                                                />
                                                <Flex sx={{ justifyContent: 'end', gap: '8px', mt: '6px' }}>
                                                    <Button
                                                        sx={{
                                                            background: theme?.colors?.white,
                                                            color: theme?.colors?.primary,
                                                            border: `1px solid ${theme?.colors?.primary}`,
                                                            textAlign: 'center',
                                                            borderRadius: '12px',
                                                        }}
                                                        onClick={handleEmailCancelClick}
                                                    >
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        sx={{ background: `${theme.colors?.primary}`, textAlign: 'center', borderRadius: '12px' }}
                                                        onClick={handleEmailSaveClick}
                                                    >
                                                        Save
                                                    </Button>
                                                </Flex>
                                            </>
                                        )}
                                </Box>
                                {/* <Text variant="SelectLabel">URL Links:</Text> */}

                            </Box>

                            <Flex sx={{ alignItems: 'center' }}>
                                <Text variant="SelectLabel" sx={{ flex: '1', color: label }}>Task:</Text>
                                {!isTaskEditing && isStageMatch && !isDeliveredCompleted && (
                                    <>
                                        {colorMode === 'light' ? (
                                            <Image
                                                src={editIcon}
                                                sx={{ cursor: 'pointer', width: '24px', height: '24px', ml: '1rem' }}
                                                onClick={handleTaskEditClick}
                                            />
                                        ) : (
                                            <LuPenLine onClick={handleTaskEditClick} style={{ cursor: 'pointer', width: '24px', height: '24px', marginLeft: '1rem', color: 'white' }} />
                                        )}
                                    </>
                                )}
                            </Flex>
                            <Box sx={{ mt: '6px', color: label }}>
                                <MultiSelect
                                    options={taskOptions}
                                    value={isTaskEditing ? editedTasks : taskName}
                                    onChange={(selected: any) => {
                                        if (isTaskEditing) {
                                            setEditedTasks(selected);
                                        }

                                    }}
                                    labelledBy="Select"
                                    disabled={!isStageMatch || !isTaskEditing || isDeliveredCompleted}
                                />
                                {loader && (
                                    <Box sx={{ position: "absolute", inset: "0", width: "100%", height: "100%", backgroundColor: 'rgba(255, 255, 255, 0.5)', display: "grid", placeContent: "center" }}>
                                        <Spinner />
                                    </Box>
                                )}
                                {(isTaskEditing ? editedTasks : taskName).length > 0 && (
                                    <Box sx={{ mt: '12px' }}>
                                        <Text variant="SelectLabel" sx={{ fontWeight: 'bold', mb: 2, color: label }}>Time Estimate:</Text>
                                        {taskOptions.map((task) => {
                                            const isSelected = taskName.some(selected => selected.value === task.value);

                                            // Find estimatedTime for this task from taskEstimateList
                                            const estimateObj = actionHighlights?.payload?.taskEstimateList?.find((t: any) => t.taskId === task.value);
                                            const estimatedTimeValue = estimateObj?.estimatedTime ? msToHours(estimateObj.estimatedTime) : '0';
                                            const isEditing = editingTaskId === task?.value;
                                            const displayValue = isEditing ? tempTimeEstimates[task.value] : estimatedTimeValue;

                                            // Disable Save button if prevValue === newValue
                                            let saveDisabled = false;
                                            if (isEditing) {
                                                const prevValue = timeToMs(estimatedTimeValue);
                                                const newValue = timeToMs(tempTimeEstimates[task.value]);
                                                saveDisabled = prevValue === newValue;
                                            }

                                            const isInPayload = !!actionHighlights?.payload?.taskEstimateList?.some((t: any) => t.taskId === task.value);

                                            // Allow editing when either the stage matches, or we're in edit-task route.
                                            const routeAllowEdit = isEditTaskRoute ? true : isStageMatch;
                                            // — allow editing when editingTaskId matches this task.
                                            const isInputDisabled = !isSelected || editingTaskId !== task.value || !routeAllowEdit || isDeliveredCompleted || isEditStagesRoute || (isEditTaskRoute && !(taskId === task.value && isInPayload));
                                            // Show the edit icon only when we're on the /edit-task route for the originating task
                                            const canStartEdit = isSelected && !isEditing && isEditTaskRoute && !isDeliveredCompleted && (taskId === task.value && isInPayload);

                                            // When the estimate is 0 it should remain grey in both stage and task views unless the user starts editing.
                                            const numericDisplay = parseFloat(String(displayValue || '0')) || 0;
                                            const showWhite = numericDisplay > 0 || isEditing || isSelected;

                                            return (
                                                <Flex key={task.value} sx={{ alignItems: 'center', mb: 2 }}>
                                                    <Box sx={{ width: '260px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                        <Text sx={{ color: isSelected && colorMode === 'light' ? 'black' : '#aaa', fontWeight: isSelected ? 'normal' : 'lighter' }}>{task.label}</Text>
                                                    </Box>
                                                    <Input
                                                        type="text"
                                                        value={displayValue}
                                                        onChange={e => {
                                                            if (!isInputDisabled) {
                                                                let v = String(e.target.value || '');
                                                                v = v.replace(/,/g, '').replace(/[^0-9.]/g, '');
                                                                // allow only one dot
                                                                const parts = v.split('.');
                                                                v = parts.length > 1 ? parts.shift() + '.' + parts.join('') : parts[0];
                                                                setTempTimeEstimates({
                                                                    ...tempTimeEstimates,
                                                                    [task.value]: v
                                                                });
                                                            }
                                                        }}
                                                        sx={{
                                                            width: '120px',
                                                            background: colorMode === 'light' ? (showWhite ? 'white' : '#f0f0f0') : (showWhite ? '#20283c' : '#383c4f'),
                                                            color: colorMode === 'light' ? (showWhite ? 'black' : '#aaa') : (showWhite ? '#fff' : '#aaa'),
                                                            cursor: !isInputDisabled ? 'text' : 'default',
                                                            ml: 0,
                                                            pointerEvents: !isInputDisabled ? 'auto' : 'none'
                                                        }}
                                                        disabled={isInputDisabled}
                                                    />
                                                    {isSelected && isEditing && (
                                                        <>
                                                            <Button
                                                                sx={{
                                                                    background: `${theme.colors?.primary}`,
                                                                    textAlign: 'center',
                                                                    borderRadius: '12px',
                                                                    ml: 1,
                                                                    opacity: saveDisabled ? 0.5 : 1,
                                                                    cursor: saveDisabled ? 'not-allowed' : 'pointer',
                                                                }}
                                                                onClick={() => handleTimeEstimateSave(task)}
                                                                disabled={saveDisabled}
                                                            >
                                                                Save
                                                            </Button>
                                                            <Button sx={{
                                                                ml: 1,
                                                                background: theme?.colors?.white,
                                                                color: theme?.colors?.primary,
                                                                border: `1px solid ${theme?.colors?.primary}`,
                                                                textAlign: 'center',
                                                                borderRadius: '12px',
                                                            }} onClick={handleTimeEstimateCancel}>
                                                                Cancel
                                                            </Button>
                                                        </>
                                                    )}
                                                    {/* Hide edit icon when in edit-task mode */}

                                                    {canStartEdit && !isEditStagesRoute && (
                                                        colorMode === 'light' ? (
                                                            <Image
                                                                src={editIcon}
                                                                sx={{ cursor: 'pointer', width: '24px', height: '24px', ml: '1rem' }}
                                                                onClick={() => {
                                                                    setEditingTaskId(task.value);
                                                                    setTempTimeEstimates({
                                                                        ...tempTimeEstimates,
                                                                        [task.value]: estimatedTimeValue
                                                                    });
                                                                }}
                                                            />
                                                        ) : (
                                                            <LuPenLine onClick={() => {
                                                                setEditingTaskId(task.value);
                                                                setTempTimeEstimates({
                                                                    ...tempTimeEstimates,
                                                                    [task.value]: estimatedTimeValue
                                                                });
                                                            }} style={{ cursor: 'pointer', width: '24px', height: '24px', marginLeft: '1rem', marginTop: '10px', color: 'white' }} />
                                                        )
                                                    )}
                                                </Flex>
                                            );
                                        })}
                                    </Box>
                                )}
                                {isTaskEditing && !isDeliveredCompleted && (
                                    <Flex sx={{ justifyContent: 'end', gap: '8px', mt: '6px' }}>
                                        <Button
                                            sx={{
                                                background: theme?.colors?.white,
                                                color: theme?.colors?.primary,
                                                border: `1px solid ${theme?.colors?.primary}`,
                                                textAlign: 'center',
                                                borderRadius: '12px',
                                            }}
                                            onClick={handleTaskCancelClick}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            sx={{ background: `${theme.colors?.primary}`, textAlign: 'center', borderRadius: '12px' }}
                                            onClick={() => handleTaskSaveClick(true)}
                                        >
                                            Save
                                        </Button>
                                    </Flex>
                                )}
                            </Box>
                            <Flex sx={{ flexDirection: 'column' }} >
                                <Flex sx={{ alignItems: 'center' }}>
                                    <Text variant="SelectLabel" sx={{ flex: '1', color: label }}>Delta:</Text>
                                    {!isDeltaEditing && isStageMatch && !isDeliveredCompleted && (
                                        <>
                                            {colorMode === 'light' ? (
                                                <Image
                                                    src={editIcon}
                                                    sx={{ cursor: 'pointer', width: '24px', height: '24px', ml: '1rem' }}
                                                    onClick={handleDeltaEditClick}
                                                />
                                            ) : (
                                                <LuPenLine onClick={handleDeltaEditClick} style={{ cursor: 'pointer', width: '24px', height: '24px', marginLeft: '1rem', color: 'white' }} />
                                            )}

                                        </>
                                    )}
                                </Flex>
                                <Box sx={{ mt: '6px' }}>
                                    {!isDeltaEditing && (
                                        <>
                                            <Inputform
                                                values={actionHighlights?.payload?.delta}
                                                Placeholder={"Enter Delta"}
                                                Name={"delta"}
                                                type='text'
                                                sx={{ color: label }}
                                                Title_sx={{ color: "grey3" }}
                                                OnChange={(e: any) => setDeltaInputValue(e.target.value)}
                                                disabled={!isStageMatch || isDeliveredCompleted}
                                            />
                                        </>
                                    )}
                                    {isDeltaEditing && (
                                        <Inputform
                                            values={deltaInputValue}
                                            Placeholder={"Enter Delta"}
                                            Name={"delta"}
                                            type='text'
                                            sx={{ color: label }}
                                            Title_sx={{ color: "grey3" }}
                                            OnChange={(e: any) => setDeltaInputValue(e.target.value)}
                                        />
                                    )}
                                </Box>
                                {isDeltaEditing && (
                                    <Flex className="mt-3" sx={{ justifyContent: 'end', gap: '8px' }}>
                                        <Button
                                            sx={{
                                                background: theme?.colors?.white,
                                                color: theme?.colors?.primary,
                                                border: `1px solid ${theme?.colors?.primary}`,
                                                textAlign: 'center',
                                                borderRadius: '12px',
                                            }}
                                            onClick={handleDeltaCancelClick}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            sx={{ background: theme?.colors?.primary, textAlign: 'center', borderRadius: '12px' }}
                                            onClick={handleDeltaSaveClick}
                                        >
                                            Save
                                        </Button>
                                    </Flex>
                                )}
                            </Flex>

                            <Flex className='mt-2'>
                                {/* <Box className=' col-6 me-2'>
                                    <Inputform
                                        label={"Version"}
                                        Placeholder={""}
                                        Name={"version"}
                                        sx={{ backgroundColor: '#a9a9a97a' }}
                                        type='text'
                                        Title_sx={{ color: "grey3" }}
                                        values={actionHighlights?.payload?.number || ""}
                                        Max_Length={10}
                                        disabled
                                    // OnChange={(event: any) => {
                                    //     const newName = event.target.value;
                                    //     setFieldValue("name", newName, true);
                                    // }}
                                    />

                                </Box> */}
                                <Box className=' col-6 ' >
                                    <Inputform
                                        label={"Created Date:"}
                                        Placeholder={""}
                                        Name={"createdAt"}
                                        sx={{ color: label }}
                                        type='text'
                                        Title_sx={{ color: "grey3" }}
                                        values={moment(actionHighlights?.createdAt).format('YYYY-MM-DD') || ""}
                                        Max_Length={10}
                                        disabled
                                    // OnChange={(event: any) => {
                                    //     const newName = event.target.value;
                                    //     setFieldValue("name", newName, true);
                                    // }}
                                    />

                                </Box>

                            </Flex>
                        </Box>
                    </Flex>

                    <Divider />

                    <div>
                        <ActionModuleTab
                            actionObject={{ ...actionObject }}
                            selectedHighlight={selectedHighlight}
                            keys={keys}
                            actionId={actionId}
                            isCompleted={actionHighlights?.payload?.isCompleted}
                        />
                    </div>

                </Card>
                <Divider />
            </ModalBody>
            <ModalFooter className='gap-2  justify-content-end p-2' style={{ backgroundColor: modalHeader }}>
                {(isEditStagesRoute && !actionHighlights?.payload?.isCompleted) && (
                    <Button variant="SaveButton" type="submit" onClick={handleForceComplete}>Force Complete</Button>
                )}
                <Button variant="SaveButton" type="submit" onClick={togglePopover}>Close</Button>
            </ModalFooter>
        </Modal>
    )
}

export default ActionBcPcChecklist;
